module.exports = __webpack_public_path__ + "img/s1.493c2a7.png";